import { enStatus } from 'interface/course';
import { IShowcaseCourse } from 'interface/showcase';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import { dateFormater } from 'utils';
interface IProps {
  course: IShowcaseCourse;
  isNewCourse: boolean;
}

const useStyles = makeStyles((theme) => ({
  inLineContent: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalLessons: {
    fontSize: 20,
    lineHeight: 1,
    color: theme.palette.common.white,
    '@media(max-width: 1440px)': {
      fontSize: 14,
    },
  },
  progress: {
    marginRight: theme.spacing(4),
    fontWeight: 700,
    color: theme.palette.success.main,
    '@media(max-width: 1440px)': {
      fontSize: 14,
    },
  },
  status: {
    background: theme.palette.success.light,
    borderRadius: 2,
    maxHeight: 20,
    fontSize: '10px !important',
    whiteSpace: 'nowrap',
    padding: theme.spacing(2, 2),
    '@media(max-width: 1440px)': {
      paddingTop: theme.spacing(1),
    },
  },
}));

const CourseFooter = (props: IProps) => {
  const classes = useStyles();
  const { total_lessons, progress_percent, expire_at, progress_bar, status } = props.course;

  return (
    <div className={classes.container}>
      <div className={classes.inLineContent}>
        {progress_bar && Boolean(progress_percent) && (
          <Typography id='shelves-course-card-progress-title' variant='h4' className={classes.progress}>
            {progress_percent}% concluído
          </Typography>
        )}
        {Boolean(total_lessons) && <Typography id='shelves-course-card-total-lessons' className={classes.totalLessons}>{total_lessons} aulas</Typography>}
      </div>
      {props.isNewCourse && Boolean(expire_at) && status !== enStatus.EXPIRED && (
        <Typography id='shelves-course-card-expire-date' variant='body2' className={classes.status}>
          Válido até {dateFormater(String(props.course.expire_at))}
        </Typography>
      )}
    </div>
  );
};

export default CourseFooter;
